export default __webpack_public_path__ + "static/media/typetruck.53198154.svg";